import { render } from "./SvgChevronRight.vue?vue&type=template&id=1c2ce348&ts=true"
import script from "./SvgChevronRight.vue?vue&type=script&lang=ts"
export * from "./SvgChevronRight.vue?vue&type=script&lang=ts"

import "./SvgChevronRight.vue?vue&type=style&index=0&id=1c2ce348&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__